/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = InProgress, 1 = Completed, 2 = Assembled, 3 = Failed
 */
export enum ProducedComponentStatus {
    InProgress = 0,
    Completed = 1,
    Assembled = 2,
    Failed = 3
}

